export default __webpack_public_path__ + "static/media/projTrack1.413a1083.png";